import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions';
import { getDatabases } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class CreateDatabase extends React.Component {
    state = {
        customerID: "",
        servertype: 0,
        dbname: "",
        creating: false,
        saveStatus: "",
        successMessage: ""
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value, saveStatus: "" })
    }

    changeServerType = (event) => {
        this.setState({ servertype: event.target.value, saveStatus: "" })
    }

    changeDBname = (event) => {
        this.setState({ dbname: event.target.value, saveStatus: "" })
    }

    handleCreateDatabase = (event) => {
        event.preventDefault()

        let selectedCustomerId = null
        if (this.props.role === "IEAdmin") {
            if (this.state.customerID === "") {
                this.setState({ saveStatus: 'Please select a customer.' })
                return
            }
            selectedCustomerId = parseInt(this.state.customerID)
        } else {
            selectedCustomerId = parseInt(this.props.currentUser.customerID)
        }

        if (this.state.dbname.trim() === "") {
            this.setState({ saveStatus: 'Please enter a database name.' })
            return
        }

        this.setState({ creating: true, saveStatus: "", successMessage: "" })

        fetch(`${process.env.REACT_APP_BACK_URL}/admin/createdb`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({ customerId: selectedCustomerId, serverType: this.state.servertype, dbname: this.state.dbname.trim() })
        })
            .then((resp) => {
                if (resp.status !== 200) {
                    return resp.text().then(text => {
                        throw new Error(this.cleanMessage(text))
                    })
                }
                return resp.text()
            })
            .then((text) => {
                this.setState({ saveStatus: 'success', successMessage: this.cleanMessage(text) })
                this.props.getDatabases()
                setTimeout(() => {
                    this.props.closePopup()
                }, 5000)
            })
            .catch((error) => {
                this.setState({ creating: false, saveStatus: error.message })
            });
    }

    // API string responses are JSON-encoded, so decode them (unwraps quotes and unescapes \n) for display
    cleanMessage = (text) => {
        try {
            const parsed = JSON.parse(text)
            return (typeof parsed === 'string') ? parsed : (text || "")
        } catch {
            return (text || "").replace(/^"|"$/g, '')
        }
    }

    populateCustomers = () => {
        if (this.props.role === "IEAdmin") {
            return (
                <>
                    <Select
                        className="myInput"
                        onChange={this.handleCustomerID}
                        value={this.state.customerID}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                        <MenuItem value="" disabled hidden>
                            Select Customer
                        </MenuItem>
                        {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                    </Select>
                </>
            )
        }

        return null
    }

    render() {
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'Create New Database'}
                {' '}
            </DialogTitle>
            <DialogContent>
                <div className="passwordResetbox">
                    {(this.props.role === "IEAdmin") && <div className="adminSelectbox">
                        <h5 className="mainLable" style={{ color: '#000' }}>Customer:</h5>
                        <div className="myInputOut">
                            {this.populateCustomers()}
                        </div>
                    </div>}
                    <h5 className="mainLable" style={{ color: '#000' }}>Server Type:</h5>
                    <div className="myInputOut">
                        <Select
                            className="myInput"
                            onChange={this.changeServerType}
                            value={this.state.servertype}
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value={0}>SQL Server</MenuItem>
                            <MenuItem value={1}>SSAS Server</MenuItem>
                        </Select>
                    </div>
                    <h5 className="mainLable" style={{ color: '#000' }}>Database Name:</h5>
                    <div className="myInputOut">
                        <input
                            type="text"
                            className="myInput"
                            onChange={this.changeDBname}
                            defaultValue={this.state.dbname}
                            placeholder="" id="database_txt" required
                        />
                    </div>
                    {this.state.saveStatus && (
                        <div style={{
                            color: this.state.saveStatus === 'success' ? '#2e7d32' : '#d32f2f',
                            marginTop: '8px',
                            fontSize: '1rem',
                            whiteSpace: 'pre-line'
                        }}>
                            {this.state.saveStatus === 'success'
                                ? `✓ ${this.state.successMessage || 'Database created successfully.'}`
                                : `✗ Failed to create database. ${this.state.saveStatus}`}
                        </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <button
                            className="btn"
                            style={{ width: 'auto' }}
                            onClick={this.handleClick}
                            id="canceldb_btn"
                        >
                            Cancel
                        </button>
                        <button
                            className="btn"
                            style={{
                                width: 'auto',
                                backgroundColor: this.state.creating ? '#9e9e9e' : '#d32f2f',
                                color: '#fff',
                                cursor: this.state.creating ? 'not-allowed' : 'pointer'
                            }}
                            onClick={this.handleCreateDatabase}
                            disabled={this.state.creating}
                            id="createdb_btn"
                        >
                            Create
                        </button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        customerList: state.users.customerList,
        currentUser: state.users.currentUser,
        role: state.users.role
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, getDatabases }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDatabase)
